import { render, staticRenderFns } from "./CustomColumnValues.vue?vue&type=template&id=8a5f2d54&scoped=true"
import script from "./CustomColumnValues.vue?vue&type=script&lang=ts"
export * from "./CustomColumnValues.vue?vue&type=script&lang=ts"
import style0 from "./CustomColumnValues.vue?vue&type=style&index=0&id=8a5f2d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5f2d54",
  null
  
)

export default component.exports